/**
 * 알림톡 발송 이력 조회 API.
 */
import { apiClient } from './client';

function unwrap<T>(res: any, fallback?: T): T {
  if (res && typeof res === 'object' && 'data' in res) {
    const d = (res as any).data;
    return (d ?? fallback ?? d) as T;
  }
  return (res ?? fallback) as T;
}

export interface KakaoAlimLogItem {
  sendSeq: number;
  triggerCode: string;
  templateCode?: string | null;
  templateName?: string | null;
  companySeq?: number | null;
  receiverPhone: string;
  receiverName?: string | null;
  resultStatus: 'SUCCESS' | 'SKIPPED' | 'FAILED' | 'STUBBED';
  resultMessage?: string | null;
  aligoMid?: number | null;
  responseCode?: number | null;
  creditAmount?: number | null;
  creditTxSeq?: number | null;
  sourceType?: string | null;
  sourceSeq?: number | null;
  requestMessage?: string | null;
  dtRegist: string;
}

export interface KakaoAlimLogPage {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  items: KakaoAlimLogItem[];
}

export interface KakaoAlimLogQuery {
  companySeq?: number;
  triggerCode?: string;
  status?: string;
  fromDate?: string;   // yyyy-MM-dd
  toDate?: string;
  keyword?: string;
  page?: number;
  size?: number;
}

const BASE = '/admin/kakao-alim-logs';

export const kakaoAlimLogApi = {
  async list(q: KakaoAlimLogQuery = {}): Promise<KakaoAlimLogPage> {
    const params = new URLSearchParams();
    if (q.companySeq != null) params.set('companySeq', String(q.companySeq));
    if (q.triggerCode) params.set('triggerCode', q.triggerCode);
    if (q.status) params.set('status', q.status);
    if (q.fromDate) params.set('fromDate', q.fromDate);
    if (q.toDate) params.set('toDate', q.toDate);
    if (q.keyword) params.set('keyword', q.keyword);
    params.set('page', String(q.page ?? 0));
    params.set('size', String(q.size ?? 30));
    const url = params.toString() ? `${BASE}?${params.toString()}` : BASE;
    return unwrap<KakaoAlimLogPage>(await apiClient.get(url), {
      page: 0, size: 30, total: 0, totalPages: 0, items: [],
    });
  },
};

export const STATUS_LABEL: Record<string, string> = {
  SUCCESS: '성공',
  SKIPPED: '스킵',
  FAILED:  '실패',
  STUBBED: '스텁',
};

export const STATUS_COLOR: Record<string, string> = {
  SUCCESS: 'bg-green-100 text-green-700',
  SKIPPED: 'bg-gray-100 text-gray-600',
  FAILED:  'bg-red-100 text-red-700',
  STUBBED: 'bg-blue-100 text-blue-700',
};
